import Main from '@/components/main';
import MemberFund from './member-fund';
import BandRecord from './bank-record';
import Commission from './commission';
import PatentFee from './patent-fee';
import MemberTransaction from './member-transaction';
import BandRecordCmb from './bank-record-cmb';
import Refund from './refund.js';
import SaleHelpOrder from './sale-help-order.js';
import rechargeFeeRate from './recharge-fee-rate.js';
export default {
    path: '/finance-management',
    name: 'finance-management',
    meta: {
        icon: 'ios-stats',
        title: '财务管理',
        showAlways: true
    },
    component: Main,
    children: [
	   ...rechargeFeeRate,
        //  ...Refund,
	   // ...SaleHelpOrder,
	   {
            path: 'sale-member-stat-list',
            name: 'sale-member-stat-list',
            meta: {
                icon: 'md-stats',
                title: '客户销售统计',
                notCache: false,
                access: ['S', 'I', 'I2', 'B', 'C', 'J'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/sale-stat/sale-member-stat-list')
        },
        {
            path: 'seedfarm-deposit-stat-list',
            name: 'seedfarm-deposit-stat-list',
            meta: {
                icon: 'md-stats',
                title: '苗场定金统计',
                notCache: false,
                access: ['S', 'I', 'I2', 'B', 'C', 'J'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/sale-stat/seedfarm-deposit-stat/seedfarm-deposit-stat-list-V2')
        },
        {
            path: 'deposit-deposit-stat-list',
            name: 'deposit-deposit-stat-list',
            meta: {
                icon: 'md-stats',
                title: '定金单定金统计',
                notCache: false,
                access: ['S', 'I', 'I2', 'B', 'C', 'J'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/sale-stat/deposit-deposit-stat/deposit-deposit-stat-list.vue')
        },
        {
            path: 'sale-station-stat-list',
            name: 'sale-station-stat-list',
            meta: {
                icon: 'md-stats',
                title: '配送费包装费统计',
                notCache: false,
                access: ['S', 'I', 'I2', 'D', 'B', 'C', 'J'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/sale-stat/sale-station-stat-list')
        },
        // {
        //     path: 'sale-inner-member-stat-list',
        //     name: 'sale-inner-member-stat-list',
        //     meta: {
        //         icon: 'md-stats',
        //         title: '内部定金统计',
        //         notCache: false,
        //         access: ['S', 'I', 'I2', 'B', 'C'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/sale-management/sale-stat/sale-inner-member-stat-list')
        // },
        {
            path: 'sale-company-stat-list',
            name: 'sale-company-stat-list',
            meta: {
                icon: 'md-stats',
                title: '内部部门统计',
                notCache: false,
                access: ['S', 'I', 'I2', 'B', 'C', 'J'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/sale-stat/sale-company-stat-list')
        },
        // {
        //     path: 'pre-sale-deposit',
        //     name: 'pre-sale-deposit',
        //     meta: {
        //         icon: 'md-stats',
        //         title: '定单比率',
        //         notCache: true,
        //         access: ['S', 'I', 'I2', 'B', 'C'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/preSale-management/preSale-deposit/preSale-deposit')
        // },
        ...MemberFund,
        ...BandRecord,
        ...BandRecordCmb,
        {
            path: 'payback-package-fee-list',
            name: 'payback-package-fee-list',
            meta: {
                icon: 'md-stats',
                title: '退纸箱费',
                notCache: true,
                access: ['S', 'I', 'I2', 'B', 'C', 'J', 'G'],
                items: [
                ]
            },
            component: () => import('@/view/finance-management/package-fee/payback-package-fee-list')
        },
        ...PatentFee,
        ...Commission,
        ...MemberTransaction,
        {
		    path: 'transaction-sum',
		    name: 'transaction-sum',
		    meta: {
		        icon: 'md-stats',
		        title: '营业汇总核对表',
		        notCache: true,
		        access: ['S', 'I', 'I2'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/finance-management/transaction-sum')
        },
        {
            path: 'abc-transaction',
            name: 'abc-transaction',
            meta: {
                icon: 'md-stats',
                title: '农行交易明细',
                notCache: true,
                access: ['I', 'I2', 'S'],
                items: [
                ]
            },
            component: () => import('@/view/finance-management/abc-transaction/abc-transaction')
        },
        {
            path: 'order-deposit-payback',
            name: 'order-deposit-payback',
            meta: {
                icon: 'ios-apps',
                title: '补漏退定金',
                notCache: true,
                access: ['I', 'S'],
                items: [
                ]
            },
            component: () => import('@/view/finance-management/deposit/order-deposit-payback')
        },
        {
            path: 'invoice-list',
            name: 'invoice-list',
            meta: {
                icon: 'ios-apps',
                title: '发票管理',
                notCache: true,
                access: ['I', 'S'],
                items: [
                ]
            },
            component: () => import('@/view/finance-management/invoice/invoice-list')
        },
        {
            path: 'invoice-account',
            name: 'invoice-account',
            meta: {
                icon: 'md-people',
                title: '开票信息审批',
                notCache: true,
                access: ['S', 'I'],
                items: [
                ]
            },
            component: () => import('@/view/sale-management/invoice-account/invoice-account')
        }
        //苗场定金，已整合到销售统计那里
        // {
        //     path: 'deposit-list',
        //     name: 'deposit-list',
        //     meta: {
        //         icon: 'md-stats',
        //         title: '苗场定金',
        //         notCache: true,
        //         access: ['S', 'I', 'B', 'C'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/finance-management/deposit/deposit-list')
        // }

    ]
};
